import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Tag,
} from "antd";

import { connect } from "react-redux";
import { req_page_ila_course, req_downloadfile_ila_course } from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";

class ILACourseList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",

    nowAcademicYear: getNowAcademicYear(new Date()),
    nowAcademicSemester: getNowAcademicSemester(new Date()),
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.current = current; // 保存當前頁，給其他方法可看到
    this.api_page_run(
      userCode,
      userLevel,
      nowAcademicYear,
      nowAcademicSemester,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    nowAcademicYear,
    nowAcademicSemester,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_ila_course(
      userCode,
      userLevel,
      nowAcademicYear,
      nowAcademicSemester,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_ila_course(
      userLevel,
      userCode,
      searchField,
      searchValue,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    const nowAcademicYear = getNowAcademicYear(new Date());
    const nowAcademicSemester = getNowAcademicSemester(new Date());
    this.setState({ nowAcademicYear, nowAcademicSemester });
    this.columns = [
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "學期",
        dataIndex: "Semester",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "開課序號",
        dataIndex: "OpenCourseKey",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "開課班級",
        dataIndex: "OpenClassName",
        width: 20,
      },
      {
        title: "授課老師",
        dataIndex: "TeacherName",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "上課地點",
        dataIndex: "CourseRoom",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "上課時間",
        dataIndex: "CourseTime",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "學生總數",
        width: 20,
        render(record) {
          return {
            props: {
              style: {
                background: "#00FFFF",
              },
            },
            children: (
              <div
                title={record.StudentTotal}
                style={{
                  color: "#0047AB",
                  fontWeight: "Bold",
                }}
              >
                <div className="text-center">{record.StudentTotal}</div>
              </div>
            ),
          };
        },
      },
      {
        title: "未前測數",
        width: 20,
        render(record) {
          return {
            props: {
              style: {
                background:
                  record.NonPreTotal === 0 ? "palegreen" : "lavenderblush",
              },
            },
            children: (
              <div
                title={record.NonPreTotal}
                style={{
                  color: record.NonPreTotal === 0 ? "green" : "red",
                  fontWeight: "Bold",
                }}
              >
                <div className="text-center">
                  {" "}
                  {record.NonPreTotal === -1 ? (
                    <Tag color="warning">
                      <span style={{ fontSize: "1.3em" }}> 未開始</span>
                    </Tag>
                  ) : (
                    record.NonPreTotal
                  )}
                </div>
              </div>
            ),
          };
        },
      },
      {
        title: "未後測數",
        width: 20,
        render(record) {
          return {
            props: {
              style: {
                background:
                  record.NonPostTotal === 0 ? "palegreen" : "lavenderblush",
              },
            },
            children: (
              <div
                title={record.NonPostTotal}
                style={{
                  color: record.NonPostTotal === 0 ? "green" : "red",
                  fontWeight: "Bold",
                }}
              >
                <div className="text-center">
                  {" "}
                  {record.NonPostTotal === -1 ? (
                    <Tag color="warning">
                      <span style={{ fontSize: "1.3em" }}> 未開始</span>
                    </Tag>
                  ) : (
                    record.NonPostTotal
                  )}
                </div>
              </div>
            ),
          };
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      nowAcademicYear,
      nowAcademicSemester,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicYear}
          onChange={(event) =>
            this.setState({ nowAcademicYear: event.target.value })
          }
        />
        <Input
          placeholder="學期"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicSemester}
          onChange={(event) =>
            this.setState({ nowAcademicSemester: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="OpenClassName">開課班級</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button type="primary" onClick={() => this.handle_data_download()}>
          <i className="fas fa-cloud-download-alt element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>下載</span>
        </Button>
        <p />
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="OpenCourseKey"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(ILACourseList);
